import {
  APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_BEGIN,
  APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_SUCCESS,
  APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_FAILURE,
  APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function addProjectCustomJsCdn(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_BEGIN,
    });
    const { projectId, version, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-js-cdn`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_SUCCESS,
              data: res.data,
            });
            toast.success('Created Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddProjectCustomJsCdnError() {
  return {
    type: APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_BEGIN:
      return {
        ...state,
        addProjectCustomJsCdnPending: true,
        addProjectCustomJsCdnError: null,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_SUCCESS:
      return {
        ...state,
        addProjectCustomJsCdnPending: false,
        addProjectCustomJsCdnError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_FAILURE:
      return {
        ...state,
        addProjectCustomJsCdnPending: false,
        addProjectCustomJsCdnError: action.data.error,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_DISMISS_ERROR:
      return {
        ...state,
        addProjectCustomJsCdnError: null,
      };

    default:
      return state;
  }
}
